
class BardAccordion {

	static init() {
		jQuery('.collapse').on('shown.bs.collapse', function () {
			jQuery(this).prev().addClass('open');
		});

		jQuery('.collapse').on('hidden.bs.collapse', function () {
			jQuery(this).prev().removeClass('open');
		});
	}
	
}

jQuery(() => {
	BardAccordion.init;
});